import axios from 'axios';
import moment from "moment";
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useMediaQuery } from '@mui/material';
import CustomDataGrid from '../../../component/DataGrid';
import { useAuthContext } from '../../../hooks/useAuthContext';
// import { useFetchRequestsQuery } from "../../../redux/slices/apiSlice";
// import { useSelector } from "react-redux";

const ApprovedData = () => {

    const { user } = useAuthContext()
    const dataGridWidth = useMediaQuery("(max-width: 1200px)")

    // approved datagrid
    const approvedColumns = [
        { field: 'rowIndex', headerName: 'No', width: 90, headerAlign: "center", align: "center" },
        {
            field: 'agent_id',
            headerName: <FormattedMessage id='agentID' />,
            minWidth: dataGridWidth ? 180 : 280,
            headerAlign: "center",
            align: "center",
            editable: false,
        },
        {
            field: 'credit_limit',
            headerName: <FormattedMessage id='amount' />,
            type: 'number',
            minWidth: dataGridWidth ? 180 : 280,
            headerAlign: "center",
            align: "center",
            editable: false,
        },
        {
            field: 'pin',
            headerName: <FormattedMessage id='credit.pin' />,
            type: 'number',
            minWidth: dataGridWidth ? 180 : 280,
            headerAlign: "center",
            align: "center",
            editable: false,
        },
        {
            field: 'updatedAt',
            headerName: <FormattedMessage id="approvedAt" />,
            valueFormatter: (params) =>
                moment(params.value).format("DD/MM/YYYY h:mma"),
            minWidth: dataGridWidth ? 250 : 280,
            headerAlign: "center",
            align: "center",
            editable: false,
        },
    ]

    const [pageState, setPageState] = useState({
        isLoading: false,
        approved: [],
        total: 0,
        page: 1,
        pageSize: 50
    })

    const fetchApproved = async () => {
        try {
            const { data } = await axios.get(`/api/v1/credit/all?status=approved&page=${pageState.page}&limit=${pageState.pageSize}`, {
                headers: { 'Authorization': `Bearer ${user.token}` }
            })

            // console.log('approved', data)

            const approvedList = data.foundRequests.map((approved, index) => ({
                ...approved,
                rowIndex: index + 1
            }))

            setPageState(old => ({ ...old, isLoading: false, approved: approvedList, total: data.pageTotal }))

        } catch (error) {
            console.error(error)
        }
    }

    useEffect(() => {
        fetchApproved()
    }, [pageState.page, pageState.pageSize])

    // const [fetchOptions, setFetchOptions] = useState({
    //     total: 0,
    //     page: 1,
    //     pageSize: 50
    // })

    const [fetchData, setFetchData] = useState([])

    // Get Data from Store
    // const { token } = useSelector((state) => state?.user)

    // console.log("token", token)

    // let data = null
    // let requestList = null
    // const { data: fetch, isLoading } = useFetchRequestsQuery({ status: "approved", page: fetchOptions.page, limit: fetchOptions.pageSize, token })

    // if (!isLoading) {
    //     data = fetch
    //     requestList = data.foundRequests.map((request, index) => ({
    //         ...request,
    //         rowIndex: index + 1
    //     }))
    // }

    // useEffect(() => {
    //     if (!isLoading) {
    //         setFetchData(requestList)
    //     }
    // }, [data])

    return (
        <CustomDataGrid
            columns={approvedColumns}
            rows={pageState.approved}
            getRowId={(row) => row._id}
        />
    );
};

export default ApprovedData